import React from "react";
import { Modal, Table } from "antd";
import styled from "@emotion/styled";
import COLORS from "common/Colors";
import { CountryTimezone } from "common/Constants";
import moment from "moment";

const StyledModal = styled(Modal)`
  width: 600px !important;

  .ant-modal-header {
    text-transform: uppercase;
    max-width: 95%;
  }
`;
const StyleLocation = styled.div`
  a {
    font-size: 12px;
  }
`;

const StyledTable = styled(Table)`
  .ant-table-content {
    overflow-x: auto;
    max-height: 500px;
    white-space: nowrap;
  }
  .ant-table-cell {
    padding: 10px;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.SECONDARY_BLACK};
  }
  .non-white {
    background: #f9f9f9;
  }
  .normal-column {
    white-space: normal;
  }
`;

function LocationBasedAttendanceList({
  displayModal,
  toggleModal,
  title,
  list,
  reportType,
  userInfo,
  userList,
}) {
  const finduser = userList?.find((item) => item?.userid === userInfo?.userid);
  const findtimeZone = CountryTimezone?.filter(
    (item) => item?.country === finduser?.managingoffice[0]
  );
  const columns = [
    {
      title: "Name",
      dataIndex: "fullname",
      key: "fullname",
      // width: '30%',
      // align: 'center'
    },
    // {
    //     title: 'Email',
    //     dataIndex: 'EmailId',
    //     key: 'EmailId',
    //     // width: '30%',
    // },
    // {
    //   title: "Department",
    //   dataIndex: "departmentname",
    //   key: "departmentname",
    //   // width: '50%',
    //   // align: 'center'
    // },
    {
      title: "Check-In Time",
      dataIndex: "checkintime",
      key: "checkintime",
      // width: '50%',
      align: "center",
      render: (text) => {
        return moment
          .utc(text, "HH:mm:ss")
          .tz(findtimeZone[0]?.Timezone)
          ?.format("hh:mm A");
      },
    },
  ];

  if (reportType === "Others" || reportType === "Other") {
    columns.push({
      title: <div>Location</div>,
      dataIndex: "location",
      key: "loginLatitude",
      className: "normal-column",
      align: "center",
      // width: '50%',
      render: (_, record) => {
        const url1 =
          "http://maps.google.com/maps/?q=" +
          record.loginLatitude +
          "," +
          record.loginLongitude +
          "";
        return (
          <div>
            {record.loginLatitude !== "" && record.loginLongitude !== "" ? (
              <>
                <StyleLocation className="location">
                  <a href={url1} target="_blank">
                    {record.loginLatitude}, {record.loginLongitude}
                  </a>
                </StyleLocation>
              </>
            ) : (
              "-"
            )}
          </div>
        );
      },
    });
  }

  return (
    <>
      <StyledModal
        title={title}
        visible={displayModal}
        onCancel={toggleModal}
        footer={null}
        destroyOnClose
      >
        <StyledTable
          dataSource={list}
          columns={columns}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="name"
          pagination={false}
        />
      </StyledModal>
    </>
  );
}

export default LocationBasedAttendanceList;
